const getDataAndVote = function(authors){
  let acc = this.$store.state.username
  console.log(122, "点赞名单",  authors)
  let key =this.$store.state.password

  let that = this
  this.steem.api.streamTransactions("head", function (err, result) {
    // console.log(234, err, result)
    if (err) {
      alert("网络有问题！请更换API节点!")
    }
    let txType = result.operations[0][0]  //获取操作类别
    let txData = result.operations[0][1]  //获取操作内容

    authors.forEach(item => {
      if (txType == "comment" & txData.author == item.author & txData.parent_author == "") {//获取作者的文章
        let permlink = txData.permlink
        let voteWeight = item.weight
        let vote = function (){
          that.steem.broadcast.vote( key, acc, item.author, permlink, voteWeight*100, function(err, result) {
            console.log(688, "点赞完成！", item.author,  txData.title)
          })
        }
        setTimeout(vote, 300000)  //5分钟后
      }
    })
  })
}

export {getDataAndVote}
